/**
 * invoiceLogger.js
 * Lightweight structured logger for the invoice pipeline.
 */

const LEVELS = { info: "info", warn: "warn", error: "error" };

let logs = [];
let sessionId = Math.random().toString(36).slice(2, 8).toUpperCase();

function log(level, stage, msg, data) {
  const entry = {
    ts: new Date().toISOString(),
    level,
    stage,
    msg,
    data: data || null,
    ms: performance.now() | 0,
  };
  logs.push(entry);
  const style = level === "error" ? "color:red" : level === "warn" ? "color:orange" : "color:#7B2D3F";
  console.log(`%c[${level.toUpperCase()}] [${stage}] ${msg}`, style, data || "");
  return entry;
}

export const invoiceLog = {
  info:  (stage, msg, data) => log(LEVELS.info,  stage, msg, data),
  warn:  (stage, msg, data) => log(LEVELS.warn,  stage, msg, data),
  error: (stage, msg, data) => log(LEVELS.error, stage, msg, data),

  startTimer(label) {
    const t0 = performance.now();
    return () => {
      const ms = ((performance.now() - t0) | 0);
      log(LEVELS.info, label, `✓ done in ${ms}ms`);
      return ms;
    };
  },

  getLogs: () => [...logs],
  getSessionId: () => sessionId,

  clear() {
    logs = [];
    sessionId = Math.random().toString(36).slice(2, 8).toUpperCase();
  },

  exportJSON() {
    const blob = new Blob([JSON.stringify({ sessionId, logs }, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `invoice-log-${sessionId}.json`;
    a.click();
    URL.revokeObjectURL(url);
  },
};